import {
  filterActiveTeamMembers,
  getMembersByIds,
} from "app/containers/Features/components/MemberSelection/helper";
import {
  selectProjectMemberList,
  selectTeamMemberList,
} from "app/containers/Features/components/MemberSelection/redux/selector";
import { SearchForEnum } from "app/containers/Features/components/MemberSelection/types";
import clsx from "clsx";
import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import ProfileAvatar from "./ProfileAvatar";

interface Props {
  id: string;
  containerClassName?: string;
  className?: string;
  circleClassName?: string;
  statusClassName?: string;
  nameClassName?: string;
  initialsClassName?: string;
  hideStatus?: boolean;
  showFor?: SearchForEnum;
  showProjectInactiveMember?: boolean;
}
const MemberProfileAvatar: React.FC<Props> = ({
  id,
  circleClassName,
  className,
  statusClassName,
  nameClassName,
  initialsClassName,
  hideStatus = false,
  containerClassName,
  showFor = SearchForEnum.project,
  showProjectInactiveMember = false,
}) => {
  const projectMembers = useSelector(selectProjectMemberList);
  const teamMembers = useSelector(selectTeamMemberList);

  const activeTeamMembers = filterActiveTeamMembers(
    showFor === SearchForEnum.project ? projectMembers : teamMembers,
  );

  const owner = useMemo(() => {
    const sourceMembers = showProjectInactiveMember
      ? showFor === SearchForEnum.project
        ? projectMembers
        : teamMembers
      : activeTeamMembers;

    return getMembersByIds(sourceMembers, id)[0];
  }, [
    activeTeamMembers,
    projectMembers,
    teamMembers,
    showProjectInactiveMember,
    showFor,
    id,
  ]);
  return (
    <div
      className={clsx("flex items-center gap-1 w-full  ", containerClassName)}
    >
      <ProfileAvatar
        name={owner?.name}
        avatar={owner?.avatar}
        circleClassName={clsx(" w-8 h-8 ", circleClassName)}
        className={className}
        hideStatus={hideStatus}
        statusClassName={statusClassName}
        initialsClassName={initialsClassName}
      />
      <span
        className={clsx(
          " text-sm font-normal text-black truncate ",
          nameClassName,
        )}
      >
        {owner?.name as string}
      </span>
    </div>
  );
};

export default MemberProfileAvatar;
